
































































































import { Component, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GradeClass, GradeSchoolClass, SchoolClass } from '@/models/school-class/school-class';
import GGroupDraggable from '@/components/GGroupDraggable.vue';
import draggable from 'vuedraggable';
import { StudentSearch } from '@/models/student/student-search';
import { GEnum } from '@/constants/enum.defination';
import { studentModule } from '@/store/modules/entities/student.module';
import { Student } from '@/models/student/student';
import { PagingData } from '@/models/core/paging-data';
import { StudentsByClass } from '@/models/student/students-by-class';
import GSchoolClassesDraggable from '@/views/GSchoolClassChange/GSchoolClassesDraggable.vue';
import { StudentSchoolClassMovement } from '@/models/student/students-arrange';
import GSchoolClassEditConfirmModal from '@/views/GSchoolClassChange/GSchoolClassChangeConfirmModal.vue';
import GSchoolClassEditWorkSpaceDraggable from '@/views/GSchoolClassChange/GSchoolClassChangeWorkSpaceDraggable.vue';
import { schoolClassChangeModule } from '@/store/modules/frames/school-class-change.module';
import { StudentDraggableExtraArea } from '@/models/student/student-draggable-extra-area';
import GSchoolClassChangeWorkSpace from '@/views/GSchoolClassChange/GSchoolClassChangeWorkSpace.vue';
import GSchoolClassBulkMoveModal from '@/views/GSchoolClassChange/GSchoolClassBulkMoveModal.vue';
import GSchoolClassChangeToolBar from '@/views/GSchoolClassChange/GSchoolClassChangeToolBar.vue';
import GSchoolClassChangeStudentTile from '@/views/GSchoolClassChange/GSchoolClassChangeStudentTile.vue';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave']);
@Component({
  name: 'GSchoolClassChange',
  components: {
    GSchoolClassChangeStudentTile,
    GSchoolClassChangeToolBar,
    GSchoolClassBulkMoveModal,
    GSchoolClassChangeWorkSpace,
    GSchoolClassEditWorkSpaceDraggable,
    GSchoolClassEditConfirmModal,
    GSchoolClassesDraggable,
    GGroupDraggable,
    GCustomBreadCrumb,
    draggable,
  },
  computed: {},
  methods: {},
})
export default class GSchoolClassChange extends Mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  selectedGrade: number = 0; // 選択した学年
  options: any = { group: 'drag_list', handle: '.person-item' };
  currentPage: number = 1; // 現在のページ
  pageSize: number = 3; // ページサイズ(クラスごと)
  initClassCounts: number[] = []; // 生徒読み込み時の各クラスの生徒件数(変更後の差分を取得する用)
  showConfirmModal: boolean = false; // 更新確認画面モーダル
  studentShowModeLabel: GEnum.RadioLabel = GEnum.RadioLabel.True; // 学生表示ラベル(名前or学籍番号)
  tempGrade: number = 0; // 学年切り替え前の値(クラス編成中の学年切り替わりによるデータ喪失を防ぐためのもの)

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.isUpdate) {
      // クラス編成中の顔面遷移はデータ喪失確認を表示する
      this.openConfirm(
        //OK押下時は画面遷移を許容する
        () => {
          next();
        },
        () => {}
      );
    } else {
      next();
    }
  }

  async mounted() {
    this.breadCrumbItems = [
      { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' },
      { title: this.$t('SETTING_AND_MANAGE').toString(), routerPath: '' },
      { title: this.$t('REGISTRANT_INFO').toString(), routerPath: '/pages/students' },
      { title: this.$t('ORGANIZE_SCHOOL_CLASS').toString(), icon: '', routerPath: '' },
    ];
    this.resetPage();
    studentModule.clean();

    await schoolClassModule.fetchSchoolClasses();
    await schoolClassModule.fetchGradesSchoolClasses();

    schoolClassModule.fetchGrades().then(() => {
      if (this.grades.length > 0) {
        this.selectedGrade = this.grades[0];
        this.handleSearchStudents();
      }
    });
  }

  get dragAreaTypeDeleteSpace(): GEnum.DragAreaType {
    return GEnum.DragAreaType.TypeDeleteSpace;
  }

  get studentDraggableExtraArea(): StudentDraggableExtraArea {
    return schoolClassChangeModule.studentDraggableExtraArea;
  }

  get True(): GEnum.RadioLabel {
    return GEnum.RadioLabel.True;
  }

  get False(): GEnum.RadioLabel {
    return GEnum.RadioLabel.False;
  }

  get isUpdate(): boolean {
    // クラスを変更した生徒がいるか、または、転校・退学の対象者が存在するか
    return this.studentSchoolClassMovements.length > 0 || this.studentDraggableExtraArea.deleteStudents.length > 0;
  }

  get schoolClasses(): SchoolClass[] {
    return schoolClassModule.schoolClasses;
  }

  get grades(): number[] {
    return schoolClassModule.gradeObjects.map((schoolGrade: GradeClass) => schoolGrade.grade);
  }

  get existWorkSpace(): boolean {
    return (
      this.studentDraggableExtraArea.noAssignStudents1.length > 0 ||
      this.studentDraggableExtraArea.noAssignStudents2.length > 0 ||
      this.studentDraggableExtraArea.noAssignStudents3.length > 0 ||
      this.studentDraggableExtraArea.noAssignStudents4.length > 0
    );
  }

  get isDragging(): boolean {
    return schoolClassChangeModule.isDragging;
  }

  get studentShowMode(): boolean {
    return schoolClassChangeModule.studentShowMode;
  }

  get students(): PagingData<Student> {
    return studentModule.students;
  }

  get studentsBySchoolClassesByPage(): StudentsByClass[] {
    return this.studentsBySchoolClasses.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
  }

  get studentSchoolClassMovements(): StudentSchoolClassMovement[] {
    return studentModule.studentSchoolClassMovements;
  }

  get studentsBySchoolClasses(): StudentsByClass[] {
    return studentModule.studentsBySchoolClasses;
  }

  // vue.draggableでD&D以外の方法でのデータ移動時にスクロールできなくなるため、仕方なくD&Dエリアをリロード表示
  handleRefresh() {
    this.refresh(20); // 20msはrerenderを適用するための間隔
  }

  handleOpenChangeGrade(open: boolean) {
    if (open) {
      this.tempGrade = this.selectedGrade;
    }
  }

  handleStudentShowMode(value: GEnum.RadioLabel) {
    schoolClassChangeModule.setStudentShowMode(this.convertRadioToBoolean(value));
  }

  handleStart(e: any) {
    schoolClassChangeModule.setIsDragging(true);
  }

  handleEnd() {
    schoolClassChangeModule.setIsDragging(false);
  }

  badgeText(initCount: number, currentCount: number): string {
    const diff: number = initCount - currentCount;
    if (diff === 0) {
      return '';
    } else if (diff > 0) {
      return `-${diff}`;
    }
    return `+${-diff}`;
  }

  handleSearchStudents() {
    if (this.isUpdate) {
      this.openConfirm(this.loadStudents, () => {
        this.selectedGrade = this.tempGrade;
      });
    } else {
      this.loadStudents();
    }
  }

  loadStudents() {
    schoolClassChangeModule.setSelectedGrade(this.selectedGrade);
    let studentSearchOptions: StudentSearch = {
      targetType: GEnum.TargetType.Grade,
      targetID: this.selectedGrade,
      limit: 0,
      offset: 0,
      hasScore: false,
    };
    studentModule.fetchStudents(studentSearchOptions).then(() => {
      this.resetPage();
      this.updateStudentsBySchoolClass();
    });
  }

  resetPage() {
    this.studentDraggableExtraArea.clean();
    this.currentPage = 1;
  }

  // 生徒一覧からクラス別の生徒に分割して更新する
  updateStudentsBySchoolClass() {
    const selectedSchoolClasses: SchoolClass[] = schoolClassModule.gradeSchoolClasses.find((gradeSchoolClass: GradeSchoolClass) => gradeSchoolClass.grade === this.selectedGrade).schoolClasses;

    const schoolClassNameMap: Map<string, SchoolClass> = selectedSchoolClasses.reduce((result: Map<string, SchoolClass>, schoolClass: SchoolClass) => {
      result.set(schoolClass.schoolClassName, schoolClass);
      return result;
    }, new Map<string, SchoolClass>());

    const noAssignKey: string = 'no-assign';

    // 現在のクラス名を基に過去の生徒情報をクラス別に振り分ける
    const studentsBySchoolClassMap: Map<string, Student[]> = this.students.data.reduce((result: Map<string, Student[]>, student: Student) => {
      const schoolClassNameKey: string = schoolClassNameMap.has(student.schoolClass.schoolClassName) ? student.schoolClass.schoolClassName : noAssignKey;
      if (!result.has(schoolClassNameKey)) {
        result.set(schoolClassNameKey, []);
      }
      result.get(schoolClassNameKey).push(student);
      return result;
    }, new Map<string, Student[]>());

    let studentsBySchoolClasses: StudentsByClass[] = selectedSchoolClasses.reduce((result: StudentsByClass[], schoolClass: SchoolClass) => {
      result.push(
        new StudentsByClass().deserialize({
          schoolClass: schoolClass,
          students: studentsBySchoolClassMap.get(schoolClass.schoolClassName),
        })
      );
      return result;
    }, []);

    studentModule.setStudentsByClasses(studentsBySchoolClasses);
    this.initClassCounts = this.studentsBySchoolClasses.reduce((result: number[], studentsBySchoolClass: StudentsByClass) => {
      result.push(studentsBySchoolClass.students.length);
      return result;
    }, []);
  }

  handlePagerChange(nextPage: number) {
    this.currentPage = nextPage;
  }

  handleAdd(e: any) {
    this.studentDraggableExtraArea.deleteStudents[e.newIndex].dragState = GEnum.DragState.Changed;
  }

  openConfirm(ok: () => void, cancel: () => void) {
    let config = {
      title: this.$t('CONFIRM_SCHOOL_CLASS_SETTING').toString(),
      onOk: () => {
        ok();
      },
      onCancel: () => {
        cancel();
        return;
      },
    };
    this.$Modal.confirm(config);
  }
}
